module.exports = "/packs/media/images/creditcards-e5f72b3e3106cd479626e21817dbf38c.jpg";